import { Icon } from '~/shared/ui/Icon/Icon';
import { InputField } from '~/shared/ui/InputField/InputField';

import { useLocalization } from '../../localization/localization';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const LoginInput = (props) => {
  const { error, ...inputProps } = props;

  const { t } = useLocalization();

  return (
    <InputField
      error={error}
      description={t('Login description')}
      inputProps={{
        ...inputProps,
        prefixIcon: <Icon name="steam" width={16} height={16} />,
        placeholder: t('Login placeholder'),
      }}
      label={t('Login label')}
    />
  );
};
